import { Component, OnInit ,Input, EventEmitter, Output } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Globals } from "../../../services/globals";
import { Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';
declare var require;
@Component({
  selector: 'app-table-resend-report',
  templateUrl: './table-resend-report.component.html',
  styleUrls: ['./table-resend-report.component.scss']
})
export class TableResendReportComponent implements OnInit, ViewCell {

  assetsUrl = '';
  resendIcon = '';
  showResend = true;
  @Input() value : string | number;
  @Input() rowData : any;

  @Output() click : EventEmitter<any> = new EventEmitter();

  constructor(
    private globals: Globals,
    private router: Router,
    private permissionService: PermissionService
  ) {
    this.assetsUrl = this.globals.getAssetsUrl();
    this.resendIcon = this.assetsUrl + 'assets/images/resend_report.svg';
  }

  ngOnInit() {
    const url = this.router.url;
    if (url.includes('analytics/saved-schedule-report')) {
      this.showResend = this.permissionService.hasPermission('email', 'Reports', 'resend');
    }
  }
  onClick(){
  	this.click.emit(this.rowData);
  }
}
